<template>
  <div class="background-01">
    <v-layout row wrap mt-4>
      <v-flex xs12 sm3 text-xs-right class="hidden-xs-only">
        <image-app class="animated fadeInLeft" :imaSize="100" imaSrc="design/gray-arrow" imaAlt=""></image-app>
      </v-flex>
      <v-flex xs12 sm7 class="animated fadeInUp dura_1">
        <ui-title-one titleAccess="¡Felicitaciones, ha creado su presupuesto!" titleLevel="h1">
          <template slot="partOne">¡Felicitaciones,<br></template>
          <template slot="partTwo">ha creado </template>
          <template slot="partThree"> su presupuesto!</template>
        </ui-title-one>
      </v-flex>
      <v-flex xs12 class="text-xs-center">
        <ui-simple-lsc  :vidTittle="'¡Felicitaciones, ha creado su presupuesto!'" videoEmbed="ADMINISTRACIONDINERO38FelicitacionesSuPresupuesto.mp4"></ui-simple-lsc>
      </v-flex>
    </v-layout>
    <v-layout row wrap justify-center text-xs-center>
      <v-flex xs12 sm1 hidden-xs-only class="animated fadeIn dura_3">
        <image-app class="animated flash" :imaSize="80" imaSrc="design/banco3-1-1" imaAlt=""></image-app>
      </v-flex>
      <v-flex xs12 sm8 md4 class="animated fadeInDown dura_2" mb-5>
        <p>
          Por favor
          <strong>guárdelo, imprímalo</strong> y cuente con este para manejar su presupuesto.
        </p><br>
        <button @click="printData()" class="animated tada infinite">
          <image-app class="hvr-grow" :imaSize="170" imaSrc="contenido/diapositiva_39" imaAlt="Guardar datos de presupuesto en PDF"></image-app>
        </button>
      </v-flex>
    </v-layout>
    <v-dialog v-model="formDialog" width="1200" height="800">
      <div id="form-print">
        <ui-calculadora-print></ui-calculadora-print>
      </div>
    </v-dialog>

  </div>
</template>

<script>
//import jsPDF from 'jspdf'
import html2pdf from "html2pdf.js";
// import html2canvas from 'html2canvas'
// import * as rasterizeHTML from 'rasterizehtml';
export default {
  data() {
    return {
      formDialog: false
    };
  },
  methods: {
    printData() {
      var html = document.getElementById("form-print").innerHTML;
      html2pdf(html, {
        margin: [0, 0, 0, 0],
        filename: "presupuesto-mensual.pdf",
        html2canvas: {
          dpi: 192,
          letterRendering: true
        },
        jsPDF: {
          unit: "in",
          format: "letter",
          orientation: "portrait"
        }
      });
    }
  },
  mounted() {
    this.$store.commit("nextShow", true);
  }
};
</script>
<style lang="scss" scoped>
.flash {
  animation-iteration-count: 6;
  animation-duration: 1.5s;
}

.tada {
  animation-duration: 3s;
  animation-delay: 6s;
  &:hover 
  {
    animation: none;
    -webkit-animation: none;
  }
}
</style>



// WEBPACK FOOTER //
// davivienda-38.vue?33fda8d3